export default __webpack_public_path__ + "static/media/eye_clockwork_torture_edit.276ff802.png";